import React, { Component, Fragment } from 'react';
import { shape, string, func, objectOf, any, arrayOf, object } from 'prop-types';
import { compose } from 'redux';
import { number, bool } from 'prop-types';
import { get, isEmpty, last, orderBy, isEqual, ceil, isNumber } from 'lodash';
import { connect } from 'react-redux';
import { Select, FormControl, MenuItem } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import styles from './styles.scss';
import { ROUTE_CAMPAIGN_TABS, selectCurrentRoutePayload } from 'state/modules/routing';
import GeoTable from './GeoTable/index';
import { setChartSelector, captureGeoChart } from 'state/modules/app/campaign';
import { HEADER_TITLE, HEADER_CHART_FILE_NAME, TABLE_FILE_NAME, UNIDENTIFINEDLOCATION } from './constants';
import { DEFAULT_TIME_ZONE_KEY } from 'components/TimeZoneSelector/constants';
import {
  GEO_CHART_ID,
  MAX_LENGTH_FIRST_PAGE_PDF_OF_GEO_FENCE,
  SINGLE_PAGE_WEB_ANALYTICS_DATA,
  COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE,
  INFO,
  NOTE,
} from '../../../helpers/constant';
import VeritoneGeoChart from '../../Geofence/VeritoneGeoChart';
import ShowAllAds from 'components/Modal/ShowAllAds';
import getUrlApi from '../../../helpers/getUrlApi';
import ModuleExport from '../../ModuleExport';
import { defaultChartSelector } from '../../../helpers/defaultInfo';
import { loadGeoFenceData, setTargetLocationPath, Status } from '../../../state/modules/app/campaign/actions';
import { TYPE_STANDARD, MARKET_ID, GEO_LOCATION_TYPE } from '../../Geofence/constant';
import DeleteReportItemButton from '../../DeleteReportItem';
import cx from 'classnames';
import { calculateTableRows } from '../Report/helper';
import { shouldShowTabDisclaimer } from '../../../helpers/common';
import MessageWithStatus from '../../MessageWithStatus';
import DeprecatedDataDisclaimer from '../TabDisclaimer/DeprecatedDataDisclaimer';
import ga4OnlyStyles from '../TabDisclaimer/styles.scss';
import { UASunsetDisclaimer } from '../ChartDisclaimer';
import { LOCATION_GRANULARITY, locationGranularityType } from '../../LocationGranularity';

export const defaultTypeOptions = {
  visits: {
    value: 'visits',
    label: 'Ad Visits'
  },
  visitsOfAds: {
    value: 'visitsOfAds',
    label: 'Ad Visits/Ads'
  },
  avgAdCost: {
    value: 'avgAdCost',
    label: 'Avg. Ad Cost'
  }
}
export const defaultGeoTypeOption = get(defaultChartSelector, [GEO_CHART_ID, 'type']);

export class GeoFencing extends Component {
  static propTypes = {
    campaign: shape({
      chartData: shape(any),
      campaign_id: number.isRequired,
    }),
    chartKey: string,
    breadcrumbLabelAll: string,
    inTabReport: bool,
    inpdf: bool,
    page: number,
    navigateCampaignWithTab: func,
    currentPayload: shape({
      advertiserId: number,
      campaignId: number,
      tab: string
    }),
    urlApi: objectOf(string),
    advertiser: shape({
      advertiser_id: number
    }),
    chartData: shape(any),
    numberPage: number,
    tableSorter: shape({
      sortKey: string,
      sortType: string
    }),
    targetLocationPath: arrayOf(string),
    typeOptions: shape({
      visits: shape({ value: string, label: string }),
      visitsPerAd: shape({ value: string, label: string }),
      avgAdCost: shape({ value: string, label: string })
    }),
    notifications: arrayOf(any),
    selectedOption: shape({
      value: string,
      label: string
    }),
    setChartSelector: func,
    captureGeoChart: func,
    loadGeoFenceData: func,
    setTargetLocationPath: func,
    itemIndex: number,
    includeUnidentifiedLocation: bool,
    identifiedCountryIds: arrayOf(string),
    isCustomReport: bool,
    showInReportConfig: shape({
      locationChart: bool,
      locationTable: bool,
    }),
    range: string,
    currentStep: string,
    imageForGeoChart: string,
    isShouldShowSunsetDisclaimer: bool,
    appSetting: arrayOf({}),
    locationGranularity: arrayOf(locationGranularityType),
    loadDataByLocationPath: func,
    isHiddenChart: bool,
  }

  static defaultProps = {
    inTabReport: false,
    inpdf: false,
    isShouldShowSunsetDisclaimer: false,
    page: 0,
    typeOptions: defaultTypeOptions,
    showInReportConfig: {},
    breadcrumbLabelAll: 'All',
    appSetting: [],
    locationGranularity: [],
  }

  state = {
    detailOpen: false,
    detailUrl: {},
    detailInfo: {}
  }

  componentDidMount() {
    this.handleSingleCountry();
    const { setTargetLocationPath, campaign, chartKey, isCustomReport, inpdf } = this.props;
    if(!isCustomReport && !inpdf) {
      setTargetLocationPath &&
      setTargetLocationPath([], campaign.campaign_id, chartKey);
    }else {
      this.handleLoadGeoFenceData();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      chartData,
      isCustomReport,
      inpdf,
      campaign,
      chartKey,
      setTargetLocationPath
    } = this.props;
    const { chartData: prevChartData, campaign: prevCampaign, chartKey: prevChartKey } = prevProps;
    const geoData = get(chartData, [GEO_CHART_ID]);
    const prevGeoData = get(prevChartData, [GEO_CHART_ID]);

    if (!isEqual(geoData, prevGeoData)) {
      this.handleSingleCountry();
    }
    
    if (isEmpty(prevGeoData) && !isEmpty(geoData) && (isCustomReport || inpdf)) {
      this.handleLoadGeoFenceData();
    }

    if(!isCustomReport && !inpdf && (
      !isEqual(campaign.campaign_id, prevCampaign.campaign_id) ||
      !isEqual(campaign.selectedAdSources, prevCampaign.selectedAdSources) ||
      !isEqual(chartKey, prevChartKey)
    )) {
      setTargetLocationPath &&
      setTargetLocationPath([], campaign.campaign_id, chartKey);
    }
  }

  handleLoadGeoFenceData() {
    const {
      campaign,
      chartKey,
      range,
      inpdf,
      loadDataByLocationPath,
    } = this.props;
    const dateRange = inpdf ? range : chartKey;
    
    const targetLocationPath = this.targetLocationPath;
    loadDataByLocationPath && loadDataByLocationPath(campaign, targetLocationPath, dateRange);
  }
  
  handleSingleCountry() {
    const { chartData, campaign, loadGeoFenceData, chartKey, range, inpdf, identifiedCountryIds } = this.props;
    const geoData = get(chartData, [GEO_CHART_ID, 'data'], {});
    const isSingleCountry = identifiedCountryIds.length === 1;

    if (this.targetLocationPath.length === 0 && isSingleCountry) {
      const singleCountryId = identifiedCountryIds[0];
      const geoDataStatus = get(chartData, [GEO_CHART_ID, 'status'], '');
      const isSingleCountryLoaded = get(geoData, [singleCountryId, 'status']) === Status.LOADED || geoDataStatus === Status.LOADING;
      !isSingleCountryLoaded && loadGeoFenceData && loadGeoFenceData(campaign, [singleCountryId], inpdf ? range : chartKey);
    }
  }

  handleBreadCrumbClick = (targetId) => e => {
    const targetLocationPath = this.targetLocationPath;
    const { setTargetLocationPath, campaign, chartKey } = this.props;
    const targetIndex = targetLocationPath.indexOf(targetId);
    const newTargetLocationPath  = targetIndex === -1 ?
                                   [] :
                                   targetLocationPath.slice(0, targetIndex + 1);
    setTargetLocationPath && setTargetLocationPath(newTargetLocationPath, campaign.campaign_id, chartKey);
  }

  handleCellClick = (data, isLocationName) => e => {
    const {
      urlApi,
      campaign,
      loadGeoFenceData,
      chartKey,
      setTargetLocationPath,
      isCustomReport,
    } = this.props;
    if (isCustomReport && !isLocationName) {
      return;
    }
    const { criterial_id, status, type: locationType, isDisableLocationName } = data;
    if (isLocationName) {
      if (isDisableLocationName) return
      // fetch target location children
      const targetLocationPath = this.targetLocationPath;
      const hasSelected = targetLocationPath.find(id=> id === criterial_id);
      if (criterial_id && !hasSelected) {
        const isLoaded = status === Status.LOADED;
        const newTargetLocationPath = [...targetLocationPath, criterial_id];
        !isLoaded && loadGeoFenceData && loadGeoFenceData(campaign, newTargetLocationPath, chartKey);
        setTargetLocationPath && setTargetLocationPath(newTargetLocationPath, campaign.campaign_id, chartKey);
      }
    } else {
      // summary drilldown
      const geoType = locationType === GEO_LOCATION_TYPE.METRO ||
                      locationType === GEO_LOCATION_TYPE.DMA ?
                      MARKET_ID : TYPE_STANDARD;
      const detailUrl = {
        urlApi: urlApi,
        campaignId: campaign.campaign_id,
        locationId: criterial_id,
        geoType
      }
      this.setState({
        detailOpen: true,
        detailUrl,
        detailInfo: { ...detailUrl }
      });
    }
  }

  handleDropdownChange = event => {
    const { setChartSelector, campaign } = this.props;
    const newTypeSelection = event.target.value;
    const campaignId = get(campaign, 'campaign_id');
    setChartSelector && setChartSelector(
      campaignId,
      GEO_CHART_ID,
      { type: newTypeSelection }
    );
  }

  drawDataSelector(isAvgCostDisabled) {
    const { typeOptions, selectedOption } = this.props;
    const { visits, visitsOfAds, avgAdCost } = typeOptions;
    return (
      <FormControl className={styles.dropDownForm}>
        <Select
          value={selectedOption.value}
          className={styles.selector}
          inputProps={{ classes: { icon: styles.icon } }}
          onChange={this.handleDropdownChange}
        >
          <MenuItem value={visitsOfAds.value}>{visitsOfAds.label}</MenuItem>
          <MenuItem value={visits.value}>{visits.label}</MenuItem>
          {!isAvgCostDisabled && <MenuItem value={avgAdCost.value}>{avgAdCost.label}</MenuItem>}
        </Select>
      </FormControl>
    );
  }

  closeDetail = () => {
    const { navigateCampaignWithTab, currentPayload } = this.props;
    const { advertiserId, campaignId, tab } = currentPayload;
    navigateCampaignWithTab(advertiserId, campaignId, tab);
    this.setState({
      detailOpen: false,
      detailInfo: {}
    });
  };

  prepChartDataForMap() {
    let targetLocationPath = this.targetLocationPath;
    const { chartData, identifiedCountryIds } = this.props;
    const geoData = get(chartData, [GEO_CHART_ID, 'data'], {});
    if (targetLocationPath.length === 0 && identifiedCountryIds.length === 1) {
      targetLocationPath = identifiedCountryIds;
      const singleCountryId = identifiedCountryIds[0];
      const singleCountryStatus = get(geoData, [singleCountryId, 'status']);
      const singleCountryLoaded = singleCountryStatus === Status.LOADED;
      if (!singleCountryLoaded){
        return { currentChartData: [], parentData: [], isMapLoading: true };
      }
    }

    if (isEmpty(targetLocationPath)) {
      return { currentChartData: Object.values(geoData), parentData: [] };
    }

    const { parentData } = targetLocationPath.reduce((accum, locationId) => {
      accum.locationKeys.push(locationId);
      const currentTargetData = get(geoData, accum.locationKeys);
      currentTargetData && accum.parentData.push({...currentTargetData});
      accum.locationKeys.push('children');
      return accum;
    }, { locationKeys: [], parentData: []} );

    const targetLocationData = last(parentData) || {};
    const targetLocationChildren = get(targetLocationData, 'children', {});

    if (isEmpty(targetLocationChildren)) {
      const newTargetLocationData = isEmpty(targetLocationData) ? [] : [{...targetLocationData, isLastNode: true}];
      return { currentChartData: newTargetLocationData, parentData };
    } else {
      return { currentChartData: Object.values(targetLocationData.children), parentData };
    }
  }

  prepChartData() {
    const targetLocationPath = this.targetLocationPath;
    const { chartData } = this.props;
    const geoData = get(chartData, [GEO_CHART_ID, 'data'], {});

    if (isEmpty(targetLocationPath)) {
      return { currentChartData: Object.values(geoData), parentData: [] };
    }

    const { parentData } = targetLocationPath.reduce((accum, locationId) => {
      accum.locationKeys.push(locationId);
      const currentTargetData = get(geoData, accum.locationKeys);
      currentTargetData && accum.parentData.push({...currentTargetData});
      accum.locationKeys.push('children');
      return accum;
    }, { locationKeys: [], parentData: []} );

    const targetLocationData = last(parentData) || {};
    const targetLocationChildren = get(targetLocationData, 'children', {});

    if (isEmpty(targetLocationChildren)) {
      const newTargetLocationData = isEmpty(targetLocationData) ? [] : [{...targetLocationData, isLastNode: true}];
      return { currentChartData: newTargetLocationData, parentData };
    } else {
      return { currentChartData: Object.values(targetLocationData.children), parentData };
    }
  }

  prepCsvData(data, isAvgCostDisabled) {
    const { visits, visitsOfAds, avgAdCost } = defaultTypeOptions;
    const csvHeaders = ['Location Name', visits.label, 'Ads', visitsOfAds.label];
    !isAvgCostDisabled && csvHeaders.push(avgAdCost.label);
    return data && data.reduce((acc, entry) => {
      const { name, visits, ads, visitsOfAds, avgAdCost } = entry;
      const formattedVisitOfAds = isNumber(visitsOfAds) ? parseFloat(visitsOfAds.toFixed(2)) : visitsOfAds;
      const csvRow = [ name, visits, ads, formattedVisitOfAds ];
      // eslint-disable-next-line lodash/prefer-lodash-typecheck
      const formattedAvgAdCost = typeof avgAdCost === 'number' ? avgAdCost.toFixed(2) : 'N/A';
      !isAvgCostDisabled && csvRow.push(formattedAvgAdCost);
      acc.push(csvRow);
      return acc;
    }, [csvHeaders]);
  }

  handleOnChartImageReady = (chartImage) => {
    const { captureGeoChart, campaign, chartKey, chartData } = this.props;
    const dataDisplay = get(chartData, [GEO_CHART_ID, "data"]);
    dataDisplay && captureGeoChart(campaign.campaign_id, chartImage, GEO_CHART_ID, chartKey);
  }

  drawBreadcrumbs() {
    const targetLocationPath = this.targetLocationPath;
    const { chartData, breadcrumbLabelAll, isCustomReport } = this.props;
    const geoData = get(chartData, [GEO_CHART_ID, 'data'], {});
    const geoDataLoaded = get(chartData, [GEO_CHART_ID, 'status']) === Status.LOADED;

    const breadcrumbChildren = [<div key={breadcrumbLabelAll} onClick={this.handleBreadCrumbClick(breadcrumbLabelAll)}>{breadcrumbLabelAll}</div>];
    let parentLocationData;
    for(let index = 0, lastIndex = targetLocationPath.length; index < lastIndex; index++) {
      const currentLocationId = targetLocationPath[index];
      const locationData = parentLocationData ?
                           get(parentLocationData, ['children', currentLocationId]) :
                           geoData[currentLocationId];
      if (locationData) {
        parentLocationData = {...locationData};
        const { name, isUnrated } = locationData;
        const locationName = isUnrated? `${name} (Unrated)` : name;
        const isLastChild = index === lastIndex-1;
        breadcrumbChildren.push(
          <div
            key={currentLocationId}
            onClick={isLastChild? undefined : this.handleBreadCrumbClick(currentLocationId)}
          >
            {locationName}
          </div>
        )
      }
    }

    return (
      <Breadcrumbs separator="›" arial-label="Breadcrumb" className={styles.breadCrumbs}>
        {(!isCustomReport || geoDataLoaded) && breadcrumbChildren}
      </Breadcrumbs>
    );
  }

  get targetLocationPath(){
    const { chartData, targetLocationPath } = this.props;
    const selectedCampLocationPath = get(chartData, [GEO_CHART_ID, 'targetLocationPath'], []);
    return targetLocationPath || selectedCampLocationPath;
  }

  chartExportContainer = React.createRef();
  tableExportContainer = React.createRef();

  render () {
    const {
      campaign,
      inTabReport,
      inpdf,
      page,
      advertiser,
      chartData,
      numberPage,
      notifications,
      selectedOption,
      tableSorter,
      isCustomReport,
      showInReportConfig,
      includeUnidentifiedLocation,
      currentStep,
      itemIndex,
      imageForGeoChart,
      isShouldShowSunsetDisclaimer,
      locationGranularity,
      appSetting,
      isHiddenChart,
    } = this.props;
    const { detailOpen, detailInfo, detailUrl } = this.state;
    const targetLocationPath = this.targetLocationPath;
    const geofenceType = get(campaign, "geoType", "location");
    const loadingStatus = get(chartData, [GEO_CHART_ID, 'status']);
    const uniqueAds = get(chartData, 'totalAds', 0);
    const isAvgCostDisabled = get(chartData, 'avgAdCost') == null;
    const isLoading = loadingStatus !== Status.LOADED;
    const { currentChartData = [] } = !isLoading && this.prepChartData();
    const {
      currentChartData : currentChartDataForMap,
      parentData: parentDataForMap,
      isMapLoading
    } = !isLoading && this.prepChartDataForMap();
    const formatedChartDataForMap = currentChartDataForMap && currentChartDataForMap.map(item => {
      const { avgAdCost, visitsOfAds } = item || {};
      return {
        ...item,
        visitsOfAds: isNumber(visitsOfAds) ? parseFloat(visitsOfAds.toFixed(2)) : visitsOfAds,
        avgAdCost: isNumber(avgAdCost) ? ceil(avgAdCost, 2) : avgAdCost,
      }
    })

    const geofenceStyle = inTabReport ? styles.geofenceReport : cx({[styles.geofenceDashboardMainView]: !isCustomReport}, styles.geofenceDashboard);
    const isGrandTotalDisplay = !inpdf || inpdf && page === numberPage - 1;
    const { locationChart, locationTable } = showInReportConfig;
    const selectedLocationGranularity = appSetting.find((item) => item.setting_name === LOCATION_GRANULARITY) || {};
    const selectedLocationGranularityId = get(selectedLocationGranularity, 'setting_value[0]', '');
    const locationGranularityItem = locationGranularity.find((item) => selectedLocationGranularityId === item.id) || {};
    const disallowedLocationLevels = get(locationGranularityItem, 'location_types', []);

    let isChartDisplay = !inpdf || (inpdf && page === 0 && !isHiddenChart);
    let isTableDisplay = inpdf ? isHiddenChart : true;
    let showDeleteChartButton = false;
    let showDeleteTableButton = false;

    if (isCustomReport) {
      isChartDisplay = locationChart && isChartDisplay;
      isTableDisplay = locationTable && isTableDisplay;
      showDeleteChartButton = locationChart;
      showDeleteTableButton = locationTable;
    }

    // calculate number rows of table per page in pdf file
    let tableRowsPerPage = inpdf
      ? page === 0
        ? (MAX_LENGTH_FIRST_PAGE_PDF_OF_GEO_FENCE + 1)
        : 25
      : 0;

    // re-calculate tableRowsPerPage if use custom report because of adding description
    if (inpdf && isCustomReport) {
      if (!isChartDisplay) {
        tableRowsPerPage = SINGLE_PAGE_WEB_ANALYTICS_DATA + 1;
      }
      tableRowsPerPage = tableRowsPerPage - COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE;
    }
    // convert to sort table data
    let currentChartDataByPage = currentChartData.map(item => {
      const { avgAdCost, type, hasChildren } = item;
      return {
        ...item,
        isDisableLocationName: disallowedLocationLevels.includes(type) || !hasChildren,
        avgAdCost: avgAdCost === 'N/A' ? null : avgAdCost,
      }
    });
    if (inpdf) {
      const { tableRowsFirstPage, tableRowsOtherPage } = calculateTableRows({ displayChart: locationChart, isCustomReport, minRows: MAX_LENGTH_FIRST_PAGE_PDF_OF_GEO_FENCE });
      const sortKey = get(tableSorter, 'sortKey', 'visitsOfAds');
      const sortType = get(tableSorter, 'sortType', 'desc');
      const sortCurrentChartDataBypage = orderBy(currentChartDataByPage,[sortKey],[sortType]);
      if (page === 0) {
        currentChartDataByPage = sortCurrentChartDataBypage.slice(0, tableRowsPerPage);
      } else {
        const startIndex = (tableRowsFirstPage + 1) + (page - 1) * (tableRowsOtherPage + 1);
        currentChartDataByPage = sortCurrentChartDataBypage.slice(startIndex, startIndex + tableRowsPerPage);
      }
    }
    const isDisplayChartContainer = !inpdf && (isChartDisplay || isTableDisplay) || inpdf && isChartDisplay;
    const isShowTabDisclaimer = shouldShowTabDisclaimer({
      advertiser,
      campaign,
    });
    const isShowTabDisclaimerInDashboardOnly =
      !inpdf && !inTabReport && !isCustomReport && isShowTabDisclaimer;

    return (
      <div data-test="locationChart"> 
        <div className={geofenceStyle}>
          {
            isDisplayChartContainer && (
              <div className={cx(
                {
                  [styles.deleteItemContainer]: currentStep === 'customize' && isChartDisplay,
                  [ga4OnlyStyles.ga4DisclaimerWrapper]: isShowTabDisclaimerInDashboardOnly,
                },
                styles.itemContainer,
              )}>
                {isShowTabDisclaimerInDashboardOnly && (
                  <Fragment>
                    <div className={cx({[ga4OnlyStyles.mask]: isShowTabDisclaimerInDashboardOnly})} />
                    <div className={cx({[ga4OnlyStyles.ga4Disclaimer]: isShowTabDisclaimerInDashboardOnly})}>
                      <MessageWithStatus 
                        type={INFO}
                        label={NOTE}
                        description={<DeprecatedDataDisclaimer tabName={HEADER_TITLE} />}
                        customStyle={{
                          toastContainer: ga4OnlyStyles.toastContainer,
                          toastContent: ga4OnlyStyles.toastContent,
                          typeIcon: ga4OnlyStyles.typeIcon,
                        }}
                      />  
                    </div>
                  </Fragment>
                )}
                {showDeleteChartButton &&
                  <DeleteReportItemButton
                    isDelete={showDeleteChartButton}
                    parentId="location"
                    componentId="locationChart"
                    customClassName={styles.deleteButton}
                    itemIndex={itemIndex}
                  />
                }
                <div className={styles.locationTitle}>
                  <div className={styles.locationText}>
                    {HEADER_TITLE}
                    {!isShowTabDisclaimerInDashboardOnly && isShouldShowSunsetDisclaimer && <UASunsetDisclaimer/>}
                  </div>
                  {isChartDisplay &&
                    <ModuleExport
                      exportImg={this.chartExportContainer}
                      className={styles.exportContainer}
                      fileName={HEADER_CHART_FILE_NAME}
                      disableCsvExport
                    />
                  }
                </div>
                <div className={styles.dropDownSelector}>
                  {this.drawDataSelector(isAvgCostDisabled)}
                </div>
                {(!(inpdf && page > 0)) && isChartDisplay &&
                  <div ref={this.chartExportContainer} className={styles.chartContainerBox}>
                    {inpdf && imageForGeoChart ? (
                      <img src={imageForGeoChart} />
                    ) : (
                      <div className={styles.veritoneGeoChart}>
                        <VeritoneGeoChart
                          geofenceData={formatedChartDataForMap}
                          parentData={parentDataForMap}
                          isDataLoading={isLoading || isMapLoading}
                          geofenceType={geofenceType}
                          selectedOption={selectedOption}
                          onChartImageReady={this.handleOnChartImageReady}
                          includeUnidentifiedLocation={includeUnidentifiedLocation}
                        />
                      </div>
                    )}
                  </div>
                }
                <div className={styles.boxAction}>
                  <div className={styles.breadCrumbsBox}>
                    {!isEmpty(targetLocationPath) && this.drawBreadcrumbs()}
                  </div>
                </div>
              </div>
            )
          }
          <div ref={this.tableExportContainer} className={cx({[styles.deleteItemContainer]: currentStep === 'customize'}, styles.itemContainer)}>
            {showDeleteTableButton &&
              <DeleteReportItemButton
                isDelete={showDeleteTableButton}
                parentId="location"
                componentId="locationTable"
                customClassName={styles.deleteButton}
                itemIndex={itemIndex}
              />
            }
            {isTableDisplay &&
              <Fragment>
                {!inTabReport && !inpdf &&
                  <ModuleExport
                    exportImg={this.tableExportContainer}
                    className={styles.exportContainer}
                    fileName={TABLE_FILE_NAME}
                    data={this.prepCsvData(currentChartData, isAvgCostDisabled)}
                  />
                }
                <GeoTable
                  isLoading={isLoading}
                  campaign={campaign}
                  data={currentChartDataByPage}
                  summaryAllData={currentChartData}
                  onCellClick={this.handleCellClick}
                  uniqueAds={uniqueAds}
                  isAvgCostDisabled={isAvgCostDisabled}
                  inpdf={inpdf}
                  inTabReport={inTabReport}
                  page={page}
                  isGrandTotalDisplay={isGrandTotalDisplay}
                  numberPage={numberPage}
                  rowsPerPage={tableRowsPerPage}
                  isCustomReport={isCustomReport}
                  initialSortStatus={tableSorter}
                  itemIndex={itemIndex}
                />
              </Fragment>
            }
          </div>
          <ShowAllAds
            id={GEO_CHART_ID}
            detailUrl={detailUrl}
            detailInfo={detailInfo}
            open={detailOpen}
            onClose={this.closeDetail}
            campaign={campaign}
            advertiser={advertiser}
            notifications={notifications}
          />
        </div>
      </div>
    )
  }
}

const ConnectedGeoFencing = connect(
  (state, props) => {
    const { campaign, chartData } = props;
    const geoTypeOption = get(campaign, ['chartSelector', GEO_CHART_ID, 'type'], defaultGeoTypeOption);
    const selectedOption = props.selectedOption || defaultTypeOptions[geoTypeOption];
    const includeUnidentifiedLocation = get(campaign, 'include_undefined_location', false);
    const geoData = get(chartData, [GEO_CHART_ID, 'data'], {});
    const identifiedCountryIds = Object.keys(geoData).reduce((acc, item) => {
      // eslint-disable-next-line lodash/prefer-includes
      if (UNIDENTIFINEDLOCATION.indexOf(item) === -1) {
        acc.push(item);
      }
      return acc;
    }, []);
    const currentStep = get(state, 'reportBuilder.currentStep', '');
    const campaignId = get(campaign, 'campaign_id');


    return {
      urlApi: getUrlApi(state),
      currentPayload: selectCurrentRoutePayload(state),
      selectedOption,
      includeUnidentifiedLocation,
      identifiedCountryIds,
      currentStep,
      campaignId,
    }
  },
    dispatch => ({
      navigateCampaignWithTab: (advertiserId, campaignId, tab) => dispatch({
        type: ROUTE_CAMPAIGN_TABS,
        payload: {
          advertiserId,
          campaignId,
          tab
        }
      }),
      setChartSelector: compose(dispatch, setChartSelector),
      captureGeoChart: compose(dispatch, captureGeoChart),
      loadGeoFenceData: compose(dispatch, loadGeoFenceData),
      setTargetLocationPath: compose(dispatch, setTargetLocationPath)
}))(GeoFencing);
export default ConnectedGeoFencing;